module.exports = "/_next/static/images/a242ea6606d44389d28cb71bb34ba84f-credit-card-limit@0.75x.png";